import { useMutation, useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { queryClient } from '@/api/react-query'
import { applicationQueryKey } from './read-application'

export type CollegeOption = {
  key: string
  name: string
  college_type: 'public' | 'private'
}

export function useColleges(search: string) {
  return useQuery({
    queryKey: ['colleges', search],
    queryFn: async () => {
      const response = await httpClient('financial').get<CollegeOption[]>(
        '/v1/college',
        { params: { name: search, active: 'true' } },
      )
      return response.data
    },
  })
}

export function useSetApplicationCollege(applicationKey: string) {
  return useMutation({
    mutationFn: async (collegeKey: string) => {
      await httpClient('financial').put(
        `/v1/application/${applicationKey}/college`,
        { college_key: collegeKey },
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationQueryKey(applicationKey) })
    },
  })
}
